import { Row } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";

import { useDisplayedOrderNumber } from "../hooks/useDisplayedOrderNumber";

export const OrderNumber: React.FC = () => {
  const orderNumber = useDisplayedOrderNumber();

  if (orderNumber) {
    return (
      <Row>
        <Typography variant="paragraphSansMedium">
          <StrictLocalMsg
            defaultMessage="Order number"
            description={{
              text: "This is title of the order number of an invoice, e.g. Order Number QZ59A8ABCA",
            }}
          />
        </Typography>
        <Spacer width="1/2x" />
        <Typography>{orderNumber}</Typography>
      </Row>
    );
  } else {
    return null;
  }
};
